/**
 * BottomOptions · 底部选项按钮列表（v4 · 由服务端 bottom_options[] 驱动）
 *
 * v4 改造：v3 阶段是前端硬编码的 PlanActions（确认创建 + 预设 refine chips）；
 * v4 改为消费 AssistantMessage.payload.bottomOptions[]，由服务端每轮 done
 * 事件给定。点击 = 把 option.value 当 user_query 发回。
 *
 * 特殊 value 规则（前端拦截做客户端动作，不发服务端）：
 *  · TODO: `client:create_folders` → 调 photobookMcp 建夹（接口对齐后实现）
 *
 * 现阶段所有 value 均直接 sendUserMessage。
 */

import React from 'react'
import classNames from 'classnames'
import type { BottomOption } from '../../../../../../types/ai-classify'
import styles from './Composer.module.scss'

export interface BottomOptionsProps {
  options: BottomOption[]
  /** 点击选项时的回调 · 父级把 value 当 user_query 发出 */
  onSelect: (value: string) => void
  disabled?: boolean
}

const BottomOptions: React.FC<BottomOptionsProps> = ({
  options,
  onSelect,
  disabled
}) => {
  if (options.length === 0) return null
  return (
    <div className={styles.quickPrompts} role="group" aria-label="操作">
      {options.map((o) => (
        <button
          key={o.value + '|' + o.label}
          type="button"
          className={classNames(styles.optionBtn, {
            [styles.optionBtnPrimary]: o.primary
          })}
          disabled={disabled}
          onClick={() => onSelect(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}

export default BottomOptions
